import React from 'react';
import Icon from '../../../components/AppIcon';

const InventorySummary = ({ summaryData }) => {
  const summaryCards = [
    {
      title: 'Total Pieces',
      value: summaryData.totalPieces.toLocaleString('en-IN'),
      change: '+12.5%',
      changeType: 'positive',
      icon: 'Package',
      color: 'bg-blue-500'
    },
    {
      title: 'Design Variety',
      value: summaryData.designCount.toString(),
      change: '+3 new',
      changeType: 'positive',
      icon: 'Palette',
      color: 'bg-purple-500'
    },
    {
      title: 'Stock Value',
      value: `₹${summaryData.stockValue.toLocaleString('en-IN')}`,
      change: '+8.2%',
      changeType: 'positive',
      icon: 'IndianRupee',
      color: 'bg-green-500'
    },
    {
      title: 'Low Stock Items',
      value: summaryData.lowStockCount.toString(),
      change: '-2 items',
      changeType: 'negative',
      icon: 'AlertTriangle',
      color: 'bg-orange-500'
    },
    {
      title: 'Reserved Stock',
      value: summaryData.reservedStock.toLocaleString('en-IN'),
      change: '+15.3%',
      changeType: 'positive',
      icon: 'Lock',
      color: 'bg-indigo-500'
    },
    {
      title: 'Available Stock',
      value: summaryData.availableStock.toLocaleString('en-IN'),
      change: '+5.7%',
      changeType: 'positive',
      icon: 'CheckCircle',
      color: 'bg-emerald-500'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-6">
      {summaryCards.map((card, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4 hover:shadow-elevation-2 transition-smooth">
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 ${card.color} rounded-lg flex items-center justify-center`}>
              <Icon name={card.icon} size={20} color="white" />
            </div>
            <div className={`text-xs font-medium px-2 py-1 rounded-full ${
              card.changeType === 'positive' ?'bg-success/10 text-success' :'bg-error/10 text-error'
            }`}>
              {card.change}
            </div>
          </div>
          <div>
            <p className="text-2xl font-bold text-foreground mb-1">{card.value}</p>
            <p className="text-sm text-muted-foreground">{card.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InventorySummary;